import isAfter from 'date-fns/isAfter';
import differenceInDays from 'date-fns/differenceInDays';

import { useMMGRSettings } from '../../../hoc/withMMGRSettings';
import { MediaManagerSDKSitesInfo } from '../../../media-manager-sdk';

const getGracePeriodDaysLeft = (
  storageQuotaGracePeriodEnd: MediaManagerSDKSitesInfo['storageQuotaGracePeriodEnd'],
): [boolean, number | undefined] => {
  const now = new Date();
  const daysLeft = differenceInDays(Date.parse(storageQuotaGracePeriodEnd), now);
  const isOnGracePeriod = isAfter(Date.parse(storageQuotaGracePeriodEnd), now);

  return [isOnGracePeriod, daysLeft > 0 ? daysLeft : undefined];
};

export const useStorageQuotaExperiment = (): {
  isStorageQuotaVisibilityEnabled: boolean;
  isStorageQuotaEnforcementEnabled: boolean;
  isStorageQuotaGracePeriodEnabled: boolean;
  gracePeriodDaysLeft?: number;
} => {
  const {
    storageQuotaVisibilityAndEnforcementExperiment,
    storageQuotaGracePeriodExperimentEnabled,
    storageQuotaGracePeriodEnd,
    metaSiteToken,
  } = useMMGRSettings().mmgrSettings;

  const [isOnGracePeriod, gracePeriodDaysLeft] = getGracePeriodDaysLeft(storageQuotaGracePeriodEnd);

  if (storageQuotaVisibilityAndEnforcementExperiment === 'enforcement') {
    return {
      isStorageQuotaVisibilityEnabled: Boolean(metaSiteToken),
      isStorageQuotaEnforcementEnabled: true,
      isStorageQuotaGracePeriodEnabled: storageQuotaGracePeriodExperimentEnabled,
      gracePeriodDaysLeft: isOnGracePeriod ? gracePeriodDaysLeft || 1 : undefined,
    };
  }

  return {
    isStorageQuotaVisibilityEnabled: false,
    isStorageQuotaEnforcementEnabled: false,
    isStorageQuotaGracePeriodEnabled: false,
    gracePeriodDaysLeft: undefined,
  };
};
